import React, { useEffect, useState } from "react";
import Config from "../Config";
import Navbar from "../Navbar";
import Sidebar from "../Sidebar";
import Cookies from "js-cookie";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Toastmodal from "../Toastmodal";
import ReactPaginate from "react-paginate";
import { useAuthHandling } from '../useAuthhandling';
import Deletemodal from "../Deletemodal";
import Nodatafound from "../Nodatafound";

function Draftlist() {
  let navigate = useNavigate();
  const { isAuthorized, handleUnauthorized } = useAuthHandling();
  const location = useLocation();
  const [toastmodal, setToastmodal] = useState(false);
  const [toastmessage, setToastmessage] = useState("");
  const [toasttype, setToasttype] = useState("");
  const [toastlarge, setToastlarge] = useState(false);
  const [paginate,setPaginate]=useState("");
  const [pagenum,setPagenum]=useState(1);


  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [blogdata, setBlogdata] = useState([]);
  const [modal_animationFlip, setmodal_animationFlip] = useState(false);
  const [pageid, setPageid] = useState("");

  function tog_animationFlip(id) {
    setmodal_animationFlip(!modal_animationFlip);
    setPageid(id)
  }

  const getinfo = async (e) => {
    const res = await fetch(`${Config.apiurl}/api/v1/crm/blog/get-draft-blogs?page=1`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${Cookies.get("a_token")}`,
      },
    });
    if (res.status === 200) {
      const data = await res.json();

      setBlogdata(data.data[0].data);
      setPaginate(data.data[0].total_pages);
    } 
    else if(res.status === 401){
      handleUnauthorized();
      getinfo();
    }
    else {
      alert("error");

    }
  };
  useEffect(() => {
    getinfo();
  }, []);

  const DeleteData = async (id) => {
    setmodal_animationFlip(false);

    const response = await fetch(
      `${Config.apiurl}/api/v1/crm/blog/delete-blog/${id}`,
      {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );


    if (response.status === 200) {
      const deletedata = await response.json();

      setToastmodal(true);
      setToastmessage("Sucessfully Deleted");
      setToasttype("success");
      setToastlarge(false);
      handlePageClick(pagenum);
    } 
    else if(response.status === 401){
      handleUnauthorized();
      DeleteData();
    }
    else {
      const deletedata = await response.json();

      setToastmodal(true);
      setToastmessage(response.message);
      setToasttype("error");
      setToastlarge(true);
    }
  };

  const fetchComments = async (currentPage) => {
    const res = await fetch(
      `${Config.apiurl}/api/v1/crm/blog/get-draft-blogs?page=${currentPage}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${Cookies.get("a_token")}`,
        },
      }
    );
    if (res.status === 200) {

    const data = await res.json();
    return data.data[0].data;
    }
    else if(res.status === 401){
      handleUnauthorized();
      fetchComments(currentPage);
    }
  };

  const handlePageClick = async (data) => {
    if(data===1){
      setPagenum(data);
      const commentsFormServer = await fetchComments(data);
      setBlogdata(commentsFormServer);
    }
    else{
    let currentPage = data.selected + 1;
    setPagenum(data);
    const commentsFormServer = await fetchComments(currentPage);

    setBlogdata(commentsFormServer);
    }
    
  };

  return (
    <>
      <div className="container-scroller">
        <Navbar />

        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          {/* partial */}
          <div className="main-panel">
            <div className="content-wrapper">


            <div className='user_list_search_all'>

                <div className='user_all_list-head'>

                    <Link  className={`user_all_list-head_a ${
          location.pathname === "/bloglist" ? "active" : ""
        }`} to="/bloglist">All List</Link>

                    <Link  className={`user_all_list-head_a ${
          location.pathname === "/draftlist" ? "active" : ""
        }`} to="/draftlist">Draft List</Link>

                </div>
               

            </div>


              <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">Draft List</h4>
                      <div className="table-responsive pt-3">
                        {blogdata?.length>0?
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th>Sl.No</th>
                              <th>Title</th>
                              <th>Draft?publish</th>
                              <th>Author Type</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {blogdata.map((element, i) => {
                              return (
                                <>
                                  <tr>
                                    <th scope="row">{i + 1}</th>
                                    <td>{element.title}</td>
                                    <td>{element.draft===false?'Publish':"Draft"} </td>
                                    <td>{element.authorType} </td>

                                    <td className="actions_td">
                                      <Link
                                      to="#"
                                        // onClick={() => deleteblog(element._id)}
                                        onClick={() => tog_animationFlip(element._id)}

                                        className="margins-2 action_icons"
                                      >
                                        <i className="fa-solid fa-trash" />
                                      </Link>
                                     
                                        <Link
                                          to={"/editblog/" + element._id}
                                          className="fa-solid fa-pen action_icons"
                                       
                                        ></Link>
                                     
                                    
                                              <Link to={"/blogview/" + element._id}   className="action_icons" >
                                             <i className="fa-solid fa-eye" />
                                             </Link>
                                           
                                      <ToastContainer />
                                    </td>
                                  </tr>
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                        :
                        <Nodatafound/>
                          }
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {paginate > 1 ? (
                <ReactPaginate
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  breakLabel={"..."}
                  pageCount={paginate}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination justify-content-center"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
      {toastmodal ? (
        <Toastmodal
          setToast={setToastmodal}
          message={toastmessage}
          type={toasttype}
          large={toastlarge}
        />
      ) : (
        ""
      )}

      {modal_animationFlip ? (
          <Deletemodal
            modal_animationFlip={modal_animationFlip}
            tog_animationFlip={tog_animationFlip}
            pageid={pageid}
            DeleteData={DeleteData}
            message={"Blog"}
          />
        ) : (
          ""
        )}
    </>
  );
}

export default Draftlist;
